<template>
  <v-card-title tile flat>
    <v-dialog v-model="status_add" persistent max-width="600">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">{{ 'workers_add.bt' | t }}</v-btn>
        <v-btn color="primary" dark @click.native="ejecutarUpsellingmailupdate()"> <v-icon>file_upload</v-icon> {{ 'consumer.upselling' | t }} </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline tw-txt-color-primary">{{ 'workers_add.title' | t }} Twitter</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form v-model="formvalid" ref="form">
              <v-layout wrap>
                <v-flex xs12 sm6 md12>
                  <v-text-field :label="$t('workers_add.description')" v-model="description" :rules="descriptionRule" required></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md12>
                  <v-text-field v-if="words.length < words_limit" :label="$t('workers_add.word')" :hint="$t('workers_add.bt_sample')" v-model="insertword" :rules="wordRule" />
                  <v-btn color="primary" v-if="words.length < words_limit" @click="addWord">{{ 'workers_add.bt_add' | t }} ({{ words.length }}/{{ words_limit }})</v-btn>
                  <v-btn color="primary" v-else @click="addWord" disabled>{{ 'workers_add.bt_add' | t }} ({{ words.length }}/{{ words_limit }})</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 md16>
                  <span class="text-md-right tw-txt-color-primary" v-for="(word, index) in words" :key="index">
                    <v-chip label outline color="#4267b2" close @input="deleteWord(word)">{{ word }}</v-chip>
                  </span>
                </v-flex>
              </v-layout>
              <v-layout row v-if="status_error">
                <v-flex md12>ERROR</v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="status_add = false">{{ 'workers_add.close' | t }}</v-btn>
          <v-btn color="blue darken-1" flat @click="confirmreg()">{{ 'workers_add.save' | t }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-title>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: ['w_type', 'btnact', 'token', 'words_limit'],
  data: () => ({
    insertword: '',
    status_add: false,
    status_error: false,
    words: [],
    description: '',
    formvalid: true
  }),
  computed: {
    ...mapGetters(['getServer', 'getUserId', 'getTokenHeader']),
    descriptionRule() {
      return [v => !!v || this.$t('workers_add.alert_1'), v => v.length < 20 || this.$t('workers_add.alert_2')]
    },
    wordRule() {
      return [v => !!v || /^([A-Za-z0-9ñÑçÇ#@_.-\s])+$/.test(v) || v === '' || this.$t('workers_add.alert_6'), v => v.length > 3 || v === '' || this.$t('workers_add.alert_5')]
    }
  },
  methods: {
    addWord() {
      if (this.$refs.form.validate()) {
        if (this.insertword && !this.words.includes(this.insertword)) {
          this.words.push(this.insertword)
          this.insertword = ''
        }
      }
    },
    deleteWord(word) {
      this.words = this.words.filter(w => w !== word)
    },
    confirmreg() {
      if (this.description !== '' && this.words.length > 0) {
        var body = { description: this.description, words: this.words }

        this.$http.post(`${window.location.protocol}//${this.w_type}.trawlingweb.com/create/?token=${this.token}`, body).then(data => {
          if (data.data.response && data.data.response.msg && data.data.response.msg === 'created') {
            this.words = []
            this.description = ''
            this.$emit('updateworkers')
            this.status_add = false
          } else {
            this.status_error = true
          }
        })
      }
    },
    ejecutarUpsellingmailupdate() {
      const server = this.getServer
      const lang = this.$i18n.locale
      this.$http.get(`${server}/users/${this.getUserId}/twitter/${lang}/upsellingmailupdate`, this.getTokenHeader).then(() => {
        console.log(`${server}/users/${this.getUserId}/twitter/${lang}/upsellingmailupdate`)
        this.$emit('actualizarUpgrade')
      })
      this.$http.get(`${server}/users/${this.getUserId}/twitter/${lang}/upsellingmailclient`, this.getTokenHeader).then(() => {
        console.log(`${server}/users/${this.getUserId}/twitter/${lang}/upsellingmailclient`)
      })
    }
  }
}
</script>

<style>
.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
